module.exports = __webpack_public_path__ + "img/android-chrome-192x192.5f071329.png";